var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('van-divider',{style:('height: ' + _vm.config.cellHeight + 'px; line-height: ' + _vm.config.cellHeight + 'px;')}),_vm._t("deles")],2)}
var staticRenderFns = []

export { render, staticRenderFns }